import CareerPage from "./Career/CareerPage"
import HeadquarterCareer from "./Career/HeadquarterCareer"
import HeadquarterCareerPage from "./Career/HeadquarterCareerPage"
import SingleJob from "./Career/SingleJob"
import CargoWagons from "./CargoWagons/CargoWagons"
import SmartBlocksRenderer from "./Common/SmartBlocksRenderer"
import ContactUs from "./ContactUs"
import Terms from "./Content/Terms"
import ContentPage from "./ContentPage/ContentPage"
import CorporateGovernance from "./CorporateGovernance/CorporateGovernance"
import EggedTransportation from "./EggedTransportation/EggedTransportation"
import Eligibility from "./Eligibility/Eligibility"
import FAQ from "./FAQ/FAQ"
import FinePayment from "./Finepayment/FinePayment"
import GeneralPage from "./GeneralPage/GeneralPage"
import HistoryPage from "./History/HistoryPage"
import Homepage from "./Homepage/Homepage"
import InformationPassengers from "./InformationPassengers/InformationPassengers"
import JourneyPlanner from "./JourneyPlanner/JourneyPlanner"
import LandingPage from "./Landing/Landing"
import MaintenancePage from "./MaintenancePage/MaintenancePage"
import NotFound from "./NotFound/NotFound"
import KavStations from "./PaymentApps/KavStationsPage"
import PaymentApps from "./PaymentApps/PaymentApps"
import RavKavServiceStationBlock from "./PaymentApps/RavKavServiceStationBlock"
import PeopleOfEgged from "./PeopleOfEgged/PeopleOfEgged"
import SitemapComp from "./Sitemap/Sitemap"
import TrafficIndividualSkeleton from "./TrafficUpdates/IndividualSkeleton"
import TrafficIndividual from "./TrafficUpdates/TrafficIndividual"
import TrafficLobby from "./TrafficUpdates/TrafficLobby"
export {
  CareerPage,
  CargoWagons as CargoWagons,
  ContactUs as ContactUs,
  ContentPage as ContentPage,
  CorporateGovernance as CorporateGovernance,
  EggedTransportation as EggedTransportation,
  Eligibility as Eligibility,
  FAQ as FAQ,
  FinePayment as FinePayment,
  GeneralPage as GeneralPage,
  HeadquarterCareer as HeadquarterCareer,
  HeadquarterCareerPage as HeadquarterCareerPage,
  HistoryPage as HistoryPage,
  Homepage as Homepage,
  InformationPassengers as InformationPassengers,
  JourneyPlanner as JourneyPlanner,
  KavStations as KavStations,
  LandingPage as LandingPage,
  MaintenancePage as MaintenancePage,
  NotFound as NotFound,
  PaymentApps as PaymentApps,
  PeopleOfEgged as PeopleOfEgged,
  RavKavServiceStationBlock as RavKavServiceStationBlock,
  SingleJob as SingleJob,
  SitemapComp as SitemapComp,
  SmartBlocksRenderer,
  Terms as Terms,
  TrafficIndividual as TrafficIndividual,
  TrafficIndividualSkeleton as TrafficIndividualSkeleton,
  TrafficLobby as TrafficLobby,
}
